<template>
  <div class="select">
    <h4 class="title1">
     <span>&nbsp;&nbsp;查询条件</span>
   </h4>
   <div class="selectColor">
     <div class="row">
       <el-row :gutter="20">
          <el-col :span="7">
            <el-row>
              <el-col :span="7">
                机构
              </el-col>
              <el-col :span="17">
                <el-cascader placeholder="请输入" :options="options" filterable change-on-select v-model="manageCom"> </el-cascader>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row>
              <el-col :span="7">销售人员</el-col>
              <el-col :span="17">
                <el-input class="input" v-model="agentName" placeholder="请输入销售人员名称"></el-input> 
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row>
              <el-col :span="7">险种名称</el-col>
              <el-col :span="17">
                <el-input class="input" v-model="riskName"  placeholder="请输入险种名称"></el-input> 
              </el-col>
            </el-row>
          </el-col>
       </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <el-row>
              <el-col :span="7">
                险种代码
              </el-col>
              <el-col :span="17">
                <el-select filterable multiple v-model="riskCodes" placeholder="请选择">
                  <el-option v-for="item in riskList" :key="item.value" :label="item.riskCode" :value="item.riskCode"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row>
              <el-col :span="7">是否在售</el-col>
              <el-col :span="17">
                <el-select v-model="getAuthData.saleState" placeholder="请选择">
                  <el-option label="全部" :value="null">全部</el-option>
                  <el-option label="在售" value="1">在售</el-option>
                  <el-option label="停售" value="0">停售</el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row>
              <el-col :span="7">授权状态</el-col>
              <el-col :span="17">
                <el-select v-model="getAuthData.authState">
                  <el-option label="全部" :value="null">全部</el-option>
                  <el-option label="已授权" value="1">已授权</el-option>
                  <el-option label="未授权" value="0">未授权</el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
       </el-row>
       <el-row :gutter="20">
         <el-col :span=7>
           <el-row>
             <el-col :span="8">销售人员编码</el-col>
             <el-col :span="16"> <el-input class="input" v-model="agentCode"  placeholder="请输入销售人员编码"></el-input></el-col>
           </el-row>
         </el-col>
       </el-row>
     </div>
     <el-row>
        <div class="right">
          <el-button type="primary" @click="search()">查询</el-button>
        </div>
     </el-row>
   </div>
      <h4 class="title1"><span>&nbsp;&nbsp;查询结果</span> <el-button class="right" type="primary" @click="exportResult">导出</el-button></h4>
      <el-table ref="filterTable" :data="result" style="width: 100%" >
        <el-table-column type="index" width="120" label="编号" align="center"> </el-table-column>
        <el-table-column prop="t2Name" label="T2名称"  align="center">
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.t2Name">{{ scope.row.t2Name }}</div>
            <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="t2Code" label="T2代码"  align="center"> 
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.t2Code">{{ scope.row.t2Code }}</div>
            <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="t3Name" label="T3名称"  align="center" > 
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.t3Name">{{ scope.row.t3Name }}</div>
            <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="t3Code" label="T3代码"  align="center"> 
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.t3Code">{{ scope.row.t3Code }}</div>
            <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="t4Name" label="T4名称"  align="center" >
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.t4Name">{{ scope.row.t4Name }}</div>
            <div slot="reference" v-else>-</div>
          </template>
         </el-table-column>
        <el-table-column prop="t4Code" label="T4代码" align="center" > 
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t4Code">{{ scope.row.t4Code }}</div>
              <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" width='120' label="销售人员姓名"  align="center" > </el-table-column>
        <el-table-column prop="agentCode" width='120' label="销售人员编码"  align="center" > </el-table-column>
        <el-table-column prop="riskName"  label="险种名称"  align="center" > </el-table-column>
        <el-table-column prop="riskCode" label="险种代码"  align="center" > </el-table-column>
        <el-table-column prop="authState" width='100' label="授权状态" align="center"> </el-table-column>
        <el-table-column prop="saleState" label="险种是否在售"  align="center" > </el-table-column>
        <el-table-column prop="authStartDate" label="授权开始时间（全产品）"  align="center">
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.authStartDate">{{ scope.row.authStartDate }}</div>
            <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="authEndDate" label="授权结束时间"  align="center" > 
          <template slot-scope="scope">
            <div slot="reference" v-if="scope.row.authEndDate">{{ scope.row.authEndDate }}</div>
            <div slot="reference" v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
          <el-pagination
            class="my-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            :current-page="currentPage1"
            layout="total, sizes, prev, pager, next, jumper"
            prev-click
            next-click
            :total="count">
          </el-pagination>
      </div>
  </div>
</template>
<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  data(){
    return {
      agentName:'',
      riskName:'',
      isSale:'',
      saleState:'',
      auth:'',
      agentCode:'',
      riskList:[],
      manageCom:[],
      manageCom1:[],
      options: [{}],
      T3:false,
      T4:false,
      riskCodes:null,
      getAuthData:{
        t2Code:"",  
        t3Code:"",
        t4Code:"",   
        riskName:"",               
        pageSize:10,               
        currentPage:1,              
        agentCode:"",
        agentName:"",
        manageCom:'',               
        riskCodes:null,
        saleState:null,
        authState:null 
      },
      count:0,
      result:[],
      currentPage1:1,
      loadUrl:'',
    }
  },
  methods:{
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function(res) {
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        that.options = JSON.parse(that.options);
        // console.log(that.options[0].children[0].value)
        that.manageCom = that.options[0].value;
        that.manageCom1 = that.options[0].value;
        // that.getAuthData.manageCom = that.options[0].children[0].value
        that.getAuthData.manageCom = that.options[0].value
        that.getAuthRiskDetail()
      });
    },
    initRiskTypes(){
      let that = this
      api.post(url.initRiskTypes, {}, function(res) {
        if (res.result.isSuccess) {
          that.riskList = res.data 
        } else {
          that.$message({

          });
        }
      });
    },
    getAuthRiskDetail(){
      let that = this
      // console.log(this.getAuthData,'getAuthData')
      api.post(url.getAuthRiskDetail, this.getAuthData, function(res) {
        if (res.result.isSuccess) {
          that.result = res.data.list
          that.count = res.data.count
        } else {

        }
      });
    },
    search(){
      this.currentPage1 = 1 
      this.getAuthData.currentPage = this.currentPage1
      this.getAuthData.agentName = this.agentName
      this.getAuthData.riskName = this.riskName
      this.getAuthData.riskCodes = this.riskCodes
      this.getAuthData.agentCode = this.agentCode
      // console.log(this.manageCom,'mangecom')
      // console.log(this.manageCom.length,'qqqqqq')
      if(this.manageCom !== 'HO'){
        if(this.manageCom.length >1){
          if(this.manageCom.length === 2){
            this.getAuthData.manageCom  = this.manageCom[1]
            // this.getAuthData.t2Code = this.manageCom[1]
            // this.getAuthData.t3Code = ''
            // this.getAuthData.t4Code = ''
          }else if(this.manageCom.length === 3){
            this.getAuthData.manageCom = this.manageCom[2]
            // this.getAuthData.t2Code = this.manageCom[1]
            // this.getAuthData.t3Code = this.manageCom[2]
            // this.getAuthData.t4Code = ''
          }else if(this.manageCom.length === 4){
            this.getAuthData.manageCom = this.manageCom[3]
            // this.getAuthData.t2Code = this.manageCom[1]
            // this.getAuthData.t3Code = this.manageCom[2]
            // this.getAuthData.t4Code = this.manageCom[3]
          }
        }else {
          this.getAuthData.manageCom = this.manageCom[0]
          // this.getAuthData.t2Code = '',
          // this.getAuthData.t3Code = '',
          // this.getAuthData.t4Code = ''
        }
      }
      this.getAuthRiskDetail()
    },
    exportResult(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let that = this
      api.post(url.exportAuthRiskDetail, this.getAuthData, function(res) {
        if(res.result.isSuccess === true){
          loading.close()
          that.loadUrl = res.data;
        }else{
          loading.close()
        }
      });
    },
    handleSizeChange(val){
      this.getAuthData.pageSize = val
      this.getAuthRiskDetail()
    },
    handleCurrentChange(val){
      this.getAuthData.currentPage = val
      this.currentPage1 = val
      this.getAuthRiskDetail()
    },
    // filterHandler(value,row,column){
    //   // console.log(value)
    //   // console.log(row)
    //   // console.log(column)
    //   const property = column['property'];
    //   return row[property] === value;
    // }
  },
  created(){
    this.initManageCom()
    this.initRiskTypes()
    // this.getAuthRiskDetail()
  },
  watch:{
    loadUrl(newValue, oldValue) {
      console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  }
}
</script>
<style scoped>
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.selectColor {
  padding-bottom: 1px;
}
.selectColor >>> .el-cascader{
  width:100%;
}
.selectColor >>> .el-input__inner {
  padding:0 10px;
}
.selectColor >>> .el-select {
  width:100%;
}
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}
.right {
  margin: 5px 22px 0 0;
  float: right;
}
.footer {
  padding: 10px 0 30px 0;
}
.my-pagination {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/exam/examManage/examSaleAuthorize.vue